<template>
  <Teleport to="body">
    <Transition name="flw-fade">
      <div v-if="showForceLogout" class="flw-overlay">
        <div class="flw-box" role="alertdialog" aria-live="assertive" aria-label="Deslogado pelo sistema">
          <div class="flw-countdown">{{ forceLogoutSecondsLeft }}</div>
          <div class="flw-title">{{ forceLogoutKind === 'session' ? 'Esta sessão foi revogada pelo Sistema' : 'Você foi deslogado pelo Sistema' }}</div>
          <div class="flw-desc">
            Caso queira revogar esta ação, clique em <strong>Continuar logado</strong>.
            Senão, você será desconectado em <strong>{{ forceLogoutSecondsLeft }}s</strong>.
          </div>
          <div class="flw-actions">
            <button type="button" class="flw-btn flw-btn--primary" @click="handleContinue">
              Continuar logado
            </button>
            <button type="button" class="flw-btn flw-btn--muted" @click="handleLogout">
              Deslogar
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { showForceLogout, forceLogoutSecondsLeft, forceLogoutKind, continueForcedSession, logoutNowForced } from '@/composables/useForceLogout'

const store  = useStore()
const router = useRouter()

function handleContinue() {
  continueForcedSession(store)
}

function handleLogout() {
  logoutNowForced(store, router)
}
</script>

<style scoped>
.flw-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, .55);
  display: flex;
  align-items: center;
  justify-content: center;
}

.flw-box {
  background: var(--white);
  border-radius: var(--r);
  padding: 32px;
  width: 340px;
  max-width: calc(100vw - 32px);
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, .3);
}

.flw-countdown {
  font-size: 40px;
  font-weight: 800;
  color: var(--red);
  margin-bottom: 8px;
  font-variant-numeric: tabular-nums;
}

.flw-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--ink-80);
  margin-bottom: 6px;
}

.flw-desc {
  font-size: 13px;
  color: var(--ink-40);
  line-height: 1.5;
  margin-bottom: 20px;
}

.flw-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.flw-btn {
  padding: 10px 16px;
  border-radius: var(--r-sm);
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  border: none;
  font-family: inherit;
}

.flw-btn--primary {
  background: var(--red);
  color: #fff;
}

.flw-btn--muted {
  background: transparent;
  color: var(--ink-40);
  border: 1px solid var(--ink-10);
}

.flw-fade-enter-active,
.flw-fade-leave-active {
  transition: opacity .15s ease;
}

.flw-fade-enter-from,
.flw-fade-leave-to {
  opacity: 0;
}
</style>
